import { ContentState } from "draft-js";

export const allDiplomaTypes = ["INITIAL", "CONTINUOUS", "ALTERNATING"] as const;
export const allDiplomaModes = ["FACE_TO_FACE", "DISTANCE", "MIXED"] as const;

export type DiplomaType = (typeof allDiplomaTypes)[number];
export type DiplomaMode = (typeof allDiplomaModes)[number];

export interface DiplomaDraft {
	title: string;
	description: ContentState;
	duration?: string;
	type: DiplomaType;
	mode: DiplomaMode;
}

export interface Diploma extends DiplomaDraft {
	id: string;
}
